import { ManufacturerModel } from "./manufacturerModel";
import { MedicineSpecificationModel } from "./medicineSpecificationModel";
import { ActiveIngredientViewModel } from "./activeIngredientViewModel";
import { SafetyDataModel } from "./safetyDataModel";
import { InactiveIngredientModel } from "./inactiveIngredientModel";

export class MedicineModel {
    public medicineId: number;
    public brandName: string;
    public medicineNumber: string;
    public additionalTitle: string;
    public overviewSummary: string;
    public overviewAboutMedicine: string;
    public overviewBeforeIntake: string;
    public overviewDosage: string;
    public overviewSideEffects: string;
    public overviewSafetyData: string;
    public overviewAdditionalInfo: string;
    public fullDescription: string;

    // public ingredientSideEffect: IngredientSideEffectModel;
    // public dosageContent: DosageContentModel;

    public activeIngredients: Array<ActiveIngredientViewModel>;
    public inactiveIngredients: Array<InactiveIngredientModel>;
    public medicineSpecifications: MedicineSpecificationModel;
    public safetyData: SafetyDataModel;
    public manufacturer: ManufacturerModel;
    public authorisationHolder: ManufacturerModel;
}